import React from 'react'
import { motion } from 'framer-motion'
import { Pie } from 'react-chartjs-2'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import { format } from 'date-fns'

ChartJS.register(ArcElement, Tooltip, Legend)

const CryptoConversionResult = ({ result }) => {
  if (!result) return null

  const data = result
  const formattedDate = format(new Date(data.timestamp), 'PPpp')

  const chartData = {
    labels: [`${data.from_symbol} Amount`, `${data.to_symbol} Received`],
    datasets: [
      {
        label: 'Conversion Breakdown',
        data: [data.amount, data.converted_amount],
        backgroundColor: ['#facc15', '#38bdf8'],
        borderWidth: 1,
        borderColor: '#111827',
      },
    ],
  }

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        labels: { color: '#fff', font: { size: 14 } },
        position: 'bottom'
      },
      tooltip: {
        callbacks: {
          label: ctx => `${ctx.label}: ${ctx.raw.toFixed(4)}`
        }
      }
    }
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="rounded-2xl p-6 shadow-xl bg-slate-800/50  text-white backdrop-blur-lg border border-white/10"
    >
      <h2 className="text-2xl font-bold mb-4">Crypto Conversion Result</h2>
      <p className="text-sm text-gray-300 mb-6">Data reflects the most recent update as of:: {formattedDate}</p>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-6">
        <InfoBlock label="Exchange" value={data.exchange} />
        <InfoBlock label="Pair" value={data.pair} />
        <InfoBlock label="Method" value={data.method} />
        <InfoBlock label={`Amount (${data.from_symbol})`} value={data.amount} />
        <InfoBlock label={`Converted (${data.to_symbol})`} value={data.converted_amount.toFixed(4)} />
        <InfoBlock label="Conversion Price" value={data.price} />
      </div>

      <div className="mt-6">
        <h3 className="text-lg font-semibold mb-2">Conversion Breakdown</h3>
        <div className="max-w-xs mx-auto">
          <Pie data={chartData} options={chartOptions} />
        </div>
      </div>
      <p className="text-xs text-gray-300 mb-6">This is tentative data and may not reflect precise values. </p>
    </motion.div>
  )
}

const InfoBlock = ({ label, value }) => (
  <div>
    <p className="text-sm text-gray-400">{label}</p>
    <p className="font-semibold">{value}</p>
  </div>
)

export default CryptoConversionResult
